__turbopack_context__.v({
  "list": "yTy17a_list",
  "panel": "yTy17a_panel",
  "root": "yTy17a_root",
  "tab": "yTy17a_tab",
  "tabLabel": "yTy17a_tabLabel",
  "tabSection": "yTy17a_tabSection",
});
